
export default [
    {
        path: "/account/login",
        name: "login",
        component: () => import(/* webpackChunkName: "email_capture" */ "../views/account/EmailCapture.vue")
    },
    {
        path: "/account/login/with-password",
        name: "login_with_password",
        component: () => import(/* webpackChunkName: "login" */ "../views/account/Login.vue")
    },
    {
        path: "/account/create",
        name: "create_account",
        component: () => import(/* webpackChunkName: "create_account" */ "../views/account/CreateAccount.vue")
    },
    {
        path: "/account/forgot-password",
        name: "forgot_password",
        component: () => import(/* webpackChunkName: "forgot_password" */ "../views/account/ForgotPassword.vue")
    },
    {
        path: "/account/my-account",
        name: "my_account",
        component: () => import(/* webpackChunkName: "my_account" */ "../views/account/AccountSettings.vue"),
        meta: { requiresAuth: true }
    },
    {
        path: "/account/linked-accounts",
        name: "manage_linked_accounts",
        component: () => import(/* webpackChunkName: "manage_linked_accounts" */ "../views/account/linked-accounts/LinkedAccountSettings.vue"),
        meta: { requiresAuth: true }
    },
    {
        path: "/account/activity",
        name: "activity",
        component: () => import(/* webpackChunkName: "activity" */ "../views/account/Activity.vue"),
        meta: { requiresAuth: true }
    },
]